export default {
  newConference: 'Nueva conferencia',
  dialInNumber: 'Número de marcación',
  host: 'Organizador',
  participants: 'Participantes',
  internationalParticipants: 'Participantes internacionales',
  internationalNumbersHeader: 'Seleccionar números de marcación internacionales',
  search: 'Buscar...',
  inviteWithText: 'Invitar con mensaje',
  inviteText: 'Únase a la conferencia de RingCentral. \n\nNúmeros de marcación: {dialInNumber} \n\n{internationals} \nAcceso de participante: {participantCode} \n\n¿Necesita un número de marcación internacional? Consulte http://www.ringcentral.com/conferencing \n\nEsta llamada de conferencia es posible gracias a Conferencias de RingCentral.',
};
